export const BREAKPOINT_SIZES = ['sm', 'md', 'lg'] as const
export const BREAKPOINT_MD = 768
export const BREAKPOINT_LG = 1260
